import { css } from 'styled-components';
import { SITE_NAME, isSiteName } from '../../utils/helpers/site-id.helper';

export const useSquaredCorners = (shouldBeSquared?: boolean): ReturnType<typeof css> => css`
    ${shouldBeSquared ? '' : isSiteName(SITE_NAME.CARSAVER) ? 'border-radius: 16px' : 'border-radius: 25px;'}
`;
